export function endpointRequireToken (url) {
  if (!url) {
    return true
  }
  const reLoginRefresh = /[/]?login\/refresh[/]?/
  const reLogin = /[/]?login[/]?$/
  const reAccRegistration = /[/]?accountregistration/
  const reAccActivation = /[/]?administration\/activate-registered-user/
  const reAccTokenValidation = /[/]?administration\/validate-activation-token/
  const reAccUserActivation = /[/]?administration\/activate-user/
  const reTreasuryBranchAutocomplete = /[/]?registry\/treasury-branches/

  const reAccReset = /[/]?administration\/reset-password/
  const reAccTokenResetValidation = /[/]?administration\/validate-reset-token/
  const reAccUserReset = /[/]?administration\/reset-user/

  // return reLoginRefresh.test(url) || !(reLogin.test(url) || reAccRegistration.test(url))
  return !(reLogin.test(url) ||
    reLoginRefresh.test(url) ||
    reAccRegistration.test(url) ||
    reAccActivation.test(url) ||
    reAccTokenValidation.test(url) ||
    reAccUserActivation.test(url) ||
    reTreasuryBranchAutocomplete.test(url) ||
    reAccReset.test(url) ||
    reAccTokenResetValidation.test(url) ||
    reAccUserReset.test(url))
}



// WEBPACK FOOTER //
// ./src/utils/endpoints.js